<template>
	<div class="forum__foot">
		<ul class="pagination">
			<li
				v-if="prev === 0"
				class="pagination__item prev disabled">Prev</li>
			<li v-else
				class="pagination__item prev">
				<router-link
					:to="{
						name: baseUrl,
						query: {
							limit: limit,
							offset: offset(prev - 1)
						}
					}">Prev</router-link>
			</li>
			<li 
				v-for="page in pageArray"
				:key="page"
				:class="{active: current === page }"
				class="pagination__item">
				<router-link
					:to="{
						name: baseUrl,
						query: {
							limit: limit,
							offset: offset(page - 1)
						}
					}"
					v-if="current !== page">
					{{ page }}
				</router-link>
				<span
					class="current"
					v-else>{{ page }}
				</span>
			</li>
			<li 
				v-if="current === endIndex"
				class="pagination__item prev disabled">
				Next
			</li>
			<li 
				v-else
				class="pagination__item next">
				<router-link
					:to="{
						name: baseUrl,
						query: {
							limit: limit,
							offset: offset(next - 1)
						}
					}">
					Next
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'Pagination',
	props: {
		options: {
			type: Object,
			default() {
				return {
					limit: 2,
					offset: 0,
					total: 0,
					baseUrl: '/'
				};
			}
		}
	},
	data() {
		return {
			total: this.options.total,
			limit: this.options.limit,
			baseUrl: this.options.baseUrl,
			maxPages: 10,
			totalPages: null
		};
	},
	created() {
		this.totalPages = Math.ceil(this.total / this.maxPages);
	},
	computed: {
		pages() {
			return Math.min(Math.ceil(this.total / this.limit), this.maxPages);
		},
		current() {
			return Math.ceil(this.options.offset / this.limit) + 1;
		},
		prev() {
			return this.current > 1 ? this.current - 1 : 0;
		},
		next() {
			return this.current < this.pages ? this.current + 1 : 0;
		},
		pageArray() {
			const arr = [];
			for (let i = this.startIndex; i <= this.endIndex; i++) {
				arr[i] = (i);
			}
			arr.splice(0, this.startIndex);
			return arr;
		},
		startIndex() {
			const midpoint = math.ceil(this.maxPages / 2);
			if (this.current <= midpoint + 1) {
				return 1;
			}
			return this.current === this.totalPages ? this.totalPages - this.maxPages + 1 : this.ciurrent - midpoint;
		},
		endIndex() {
			return Math.min(this.startIndex + this.maxPages, this.totalPages);
		}
	},
	methods: {
		offset(page) {
			return page <= 0 ? 0 : this.limit * page; 
		}
	}
};
</script>


<style lang="scss" scoped>
	a {
		&:hover {
			color: inherit;
		}
	}
	.disabled {
		&:hover {
			cursor: not-allowed;
			color: #bdbdbd;
		}
		a {
			&:hover {
				cursor: not-allowed;
				color: #bdbdbd;
			}
		}
	}
	.active {
		color: #fff;
	}
</style>
